// eslint-disable-next-line
export enum BatchedUpdates {
  GET_COMPANIES = 'GET_COMPANIES',
  GET_COMPANIES_DATA = 'GET_COMPANIES_DATA',
  GET_CONTACTS = 'GET_CONTACTS',
  GET_CONTACTS_DATA = 'GET_CONTACTS_DATA',
  GET_FIELDS = 'GET_FIELDS',
}

export enum BatchedModels {
  CONTACT = 'Contact',
  COMPANY = 'Company',
  FIELD = 'Field',
}
